const LG_BREAKPOINT = 1200;

export default function initTooltip() {
  const tooltips = document.querySelectorAll(".tooltip");

  if (!tooltips.length) return;

  tooltips.forEach((tooltip) => {
    const trigger = tooltip.querySelector(".tooltip-trigger");
    const content = tooltip.querySelector(".tooltip-content");

    if (!trigger || !content) return;

    function getOptimalPosition() {
      const rect = tooltip.getBoundingClientRect();
      const isDesktop = window.innerWidth >= LG_BREAKPOINT;
      const tooltipHeight = 200; // estimated max height
      const tooltipWidth = 280; // max-width

      if (isDesktop) {
        // Desktop: prefer bottom, but check if it would overflow
        const spaceBottom = window.innerHeight - rect.bottom;
        const spaceTop = rect.top;

        if (spaceBottom >= tooltipHeight + 16) {
          return "bottom";
        } else if (spaceTop >= tooltipHeight + 16) {
          return "top";
        }
        // Fallback to bottom
        return "bottom";
      }

      // Mobile: check left/right space
      const spaceLeft = rect.left;
      const spaceRight = window.innerWidth - rect.right;

      // Prefer right if enough space, otherwise left
      if (spaceRight >= tooltipWidth + 16) {
        return "right";
      } else if (spaceLeft >= tooltipWidth + 16) {
        return "left";
      }

      // Fallback to bottom if neither side has space
      return "bottom";
    }

    function getHorizontalAlign() {
      const rect = tooltip.getBoundingClientRect();
      const tooltipWidth = 280;
      const halfWidth = tooltipWidth / 2;
      const triggerCenter = rect.left + rect.width / 2;

      // Check if centered tooltip would overflow right
      if (triggerCenter + halfWidth > window.innerWidth - 16) {
        return "right"; // align tooltip to right edge of trigger
      }
      // Check if centered tooltip would overflow left
      if (triggerCenter - halfWidth < 16) {
        return "left"; // align tooltip to left edge of trigger
      }
      return "center";
    }

    function showTooltip() {
      const position = getOptimalPosition();
      const align = getHorizontalAlign();
      content.setAttribute("data-position", position);
      content.setAttribute("data-align", align);
      tooltip.classList.add("is-active");
    }

    function hideTooltip() {
      tooltip.classList.remove("is-active");
      content.removeAttribute("data-position");
      content.removeAttribute("data-align");
    }

    function toggleTooltip(e) {
      e.preventDefault();
      e.stopPropagation();

      if (tooltip.classList.contains("is-active")) {
        hideTooltip();
      } else {
        // Close other tooltips
        tooltips.forEach((t) => {
          t.classList.remove("is-active");
          const otherContent = t.querySelector(".tooltip-content");
          if (otherContent) otherContent.removeAttribute("data-position");
        });
        showTooltip();
      }
    }

    // Desktop: hover on entire tooltip wrapper (not just trigger) to prevent flicker
    if (window.innerWidth >= LG_BREAKPOINT) {
      tooltip.addEventListener("mouseenter", showTooltip);
      tooltip.addEventListener("mouseleave", hideTooltip);
    }

    // Click for mobile (and optional for desktop)
    trigger.addEventListener("click", toggleTooltip);

    // Close on outside click
    document.addEventListener("click", (e) => {
      if (!tooltip.contains(e.target)) {
        hideTooltip();
      }
    });

    // Close on escape
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        hideTooltip();
      }
    });

    // Update on resize
    window.addEventListener("resize", () => {
      if (tooltip.classList.contains("is-active")) {
        const position = getOptimalPosition();
        content.setAttribute("data-position", position);
      }

      // Re-attach hover events based on screen size
      if (window.innerWidth >= LG_BREAKPOINT) {
        tooltip.addEventListener("mouseenter", showTooltip);
        tooltip.addEventListener("mouseleave", hideTooltip);
      } else {
        tooltip.removeEventListener("mouseenter", showTooltip);
        tooltip.removeEventListener("mouseleave", hideTooltip);
      }
    });
  });
}
